module.exports = "/next-static/_next/static/images/block_image_invite_guests-8a05af3dc70e2c276b1644c17c84e29c.webp";